import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'registration',
    loadChildren: () =>
      import('./modules/registration/registration.module').then((m) => m.RegistrationModule),
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'external',
    loadChildren: () => import('./modules/external/external.module').then((m) => m.ExternalModule),
  },
  {
    path: 'tv-media',
    loadChildren: () => import('./modules/tv-media/tv-media.module').then((m) => m.TvMediaModule),
  },
  {
    path: 'plasma-ketersediaan-tempat-tidur',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/plasma-ketersediaan-tempat-tidur/plasma-ketersediaan-tempat-tidur.module'
      ).then((m) => m.PlasmaKetersediaanTempatTidurModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
